export const TEXT_AREA_DEFAULT_CHAR_LIMIT = 500;
